export function getParameterByName( paramName: string ) : any {
	let url = window.location.href;
	let regex = new RegExp('[?&]' + paramName + '(=([^&#]*)|&|#|$)');
	let results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Read a cookie by name.
 * 
 * Verification in Chrome DevTools Console:
 * 1) Set test cookie: document.cookie = "euconsent-v2=TEST123; path=/; max-age=31536000";
 * 2) Check exists: document.cookie.includes("euconsent-v2=")
 * 3) Read it: document.cookie.split('; ').find(x => x.startsWith('euconsent-v2='))
 */
export function getCookie(name: string) : string {
    const cookieDebug = getParameterByName('ampCookieDebug') === '1';
    
    name = name + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookies = decodedCookie.split(';');
    
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.indexOf(name) == 0) {
        const value = cookie.substring(name.length, cookie.length);
        if (cookieDebug) {
          ampLogInfo(`getCookie(${name.slice(0, -1)}): Found value (length=${value.length})`);
        }
        return value;
      }
    }

    if (cookieDebug) {
      ampLogWarning(`getCookie(${name.slice(0, -1)}): Not found in document.cookie`);
    }
    return '';
}

/**
 * Cookie options interface for flexible cookie configuration.
 */
export interface CookieOptions {
  path?: string;           // Default: "/"
  domain?: string;         // Default: undefined (current domain)
  sameSite?: 'Lax' | 'Strict' | 'None';  // Default: auto-detected
  secure?: boolean;        // Default: auto-detected from protocol
  maxAgeSeconds?: number;  // Optional: use instead of expires
}

/**
 * Set a cookie with proper Chrome-compatible attributes.
 * 
 * Chrome Requirements:
 * - HTTPS: Can use "SameSite=None; Secure" together
 * - HTTP/localhost: Use "SameSite=Lax" without Secure
 * - Always include "path=/" for site-wide access
 * - NEVER use SameSite=None without Secure (Chrome will reject it)
 * 
 * @param name - Cookie name
 * @param value - Cookie value (will be stored as-is, no encoding)
 * @param expireDays - Number of days until expiration
 * @param options - Optional cookie configuration
 */
export function setCookie( name: string, value: string, expireDays: number, options?: CookieOptions )  {
    const cookieDebug = getParameterByName('ampCookieDebug') === '1' || getParameterByName('ampGPPDebug') === '1';
    
    // Calculate expiration
    const now = new Date();
    now.setTime(now.getTime() + (expireDays * 24 * 60 * 60 * 1000));
    const expires = now.toUTCString();
    
    // Determine defaults
    const isHttps = location.protocol === 'https:';
    const path = options?.path ?? '/';
    const domain = options?.domain;  // undefined = current domain
    
    // Auto-detect secure and sameSite based on protocol
    let secure = options?.secure ?? isHttps;
    let sameSite = options?.sameSite;
    
    if (!sameSite) {
      // Auto-detect: use Lax for localhost/http, None for https (if secure)
      sameSite = (isHttps && secure) ? 'None' : 'Lax';
    }
    
    // CRITICAL: If SameSite=None, MUST have Secure=true (Chrome requirement)
    if (sameSite === 'None' && !secure) {
      if (cookieDebug) {
        ampLogWarning(`setCookie(${name}): SameSite=None requires Secure=true. Falling back to SameSite=Lax`);
      }
      sameSite = 'Lax';
      secure = false;
    }
    
    // Build cookie string
    let cookieString = `${name}=${value}; path=${path}`;
    
    if (options?.maxAgeSeconds) {
      cookieString += `; max-age=${options.maxAgeSeconds}`;
    } else {
      cookieString += `; expires=${expires}`;
    }
    
    if (domain) {
      cookieString += `; domain=${domain}`;
    }
    
    cookieString += `; SameSite=${sameSite}`;
    
    if (secure) {
      cookieString += '; Secure';
    }
    
    if (cookieDebug) {
      ampLogInfo(`setCookie(${name}): ${cookieString.substring(0, 120)}...`);
    }
    
    document.cookie = cookieString;
    
    // Verify the cookie was set
    if (cookieDebug) {
      const verification = document.cookie.split('; ').find(x => x.startsWith(`${name}=`));
      if (verification) {
        ampLogInfo(`setCookie(${name}): ✓ Cookie verified in document.cookie`);
      } else {
        ampLogError(`setCookie(${name}): ✗ Cookie NOT found in document.cookie after setting!`);
        ampLogError(`  Protocol: ${location.protocol}, Secure: ${secure}, SameSite: ${sameSite}`);
      }
    }
}

/**
 * Set a cookie with expiration time in milliseconds.
 * 
 * This function was previously unimplemented. Now it properly sets cookies
 * with Chrome-compatible attributes (SameSite, Secure, path).
 * 
 * @param key - Cookie name
 * @param value - Cookie value (will be stored as-is, no encoding)
 * @param expireTimeMs - Expiration time in milliseconds from now
 * @param options - Optional cookie configuration
 */
export function setCookieWithExpireTime ( key:string, value:string, expireTimeMs:number, options?: CookieOptions) : void {
    // Convert milliseconds to days and use setCookie
    const expireDays = expireTimeMs / (24 * 60 * 60 * 1000);
    setCookie(key, value, expireDays, options);
}


////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
//
//  Console
//

const gLogTitle : string = "GPP CMP";
const gDebugLevel : number = 0;

export function getCallerContext() {

	// let e  = new Error();
	// let stack  = e.stack;
	// let line  = stack.split("\n")[4];
	// let lineParts = line.split(":");
	// return lineParts[2]; 
}

export function doConsolePrint( ...args : [string] ) {
		queueMicrotask (console.log.bind (console, ...args));
}

export function doAmpLog( ampHead :string, msg:string, msgStyle:string ) {
		
// @ts-ignore
		let lineNumberText  :string = undefined; // "Line " + getCallerContext();
		
		let ampHeadStyle :string  = "background-color:#430F64;border:solid 1px #7E31AE;padding:2px 8px;border-radius:2px;font-weight:900;color:#ded;margin-right:6px;"
		let lineNumberStyle :string  = "background-color:#430F64;border:solid 1px #7E31AE;padding:2px 8px;border-radius:2px;color:#cdc;margin-right:10px;margin-top:-1px;font-size:80%;font-weight:500;"

		if ( msg ) {
// @ts-ignore
				doConsolePrint( "%c" + ampHead + "%c" + msg  , ampHeadStyle, msgStyle );
		}
		else
// @ts-ignore
			doConsolePrint( "%c" + ampHead, ampHeadStyle );
}

export function ampLogInfo( msg:string ) {
		doAmpLog( gLogTitle, msg, "font-weight:500;" ) 
}

export function ampLogDebug( level:number, msg:string ) {
		if ( gDebugLevel >= level) 
		doAmpLog( gLogTitle, msg, "font-weight:500;color:#888;" );
}

export function ampLogError( msg:string ) {
		let msgStyle = "width:100%;background-color:#7b2222;padding:2px 4px;border-radius:2px;font-weight:500;color:#EEF;margin-right:4px;";
		doAmpLog( gLogTitle, "Error: " + msg, msgStyle ) 
}

 export function ampLogWarning( msg:string ) {
		let msgStyle = "width:100%;background-color:#7a7222;padding:2px 4px;border-radius:2px;font-weight:500;color:#EEF;margin-right:4px;";
		doAmpLog( gLogTitle, "Warning: " + msg, msgStyle ) 
}


